import { FC } from "react"
import { useTranslation } from "react-i18next"

import { ISummarySection } from "@/types"
import { IListItem } from "components/List/List"
import Summary from "components/Summary/Summary"
import useAssetFields, { AssetField } from "../../hooks/useAssetFields"
import { AssetStep } from "pages/AssetPage/config"
import { useAssetDataContext } from "./AssetDataContext"

interface IAssetDataFinanceProps {
    discountCalculated?: number | null
    salesPrice?: number | null
    salesPriceAdjustedCondition?: number | null
}

const AssetDataFinance: FC<IAssetDataFinanceProps> = ({
    discountCalculated,
    salesPrice,
    salesPriceAdjustedCondition,
}) => {
    const { t } = useTranslation()
    const { asset, article, pinnable, getEditLink, onEditClick } = useAssetDataContext()
    const { getFields } = useAssetFields({
        asset,
        article,
        discountCalculated,
        salesPrice,
        salesPriceAdjustedCondition,
        pinnable,
    })

    const summaryData: ISummarySection<IListItem>[] = [
        {
            title: t('asset.finance'),
            items: [],
            subSections: [
                {
                    title: t('asset.referenceNumbers'),
                    items: getFields([
                        AssetField.referenceNumberSale,
                        AssetField.referenceNumberRental,
                        AssetField.referenceValue,
                        AssetField.monthlyRentalCosts,
                        AssetField.referenceValueCorrection,
                        AssetField.referenceValueCorrected,
                    ]),
                },
                {
                    title: t('asset.listPrice'),
                    items: getFields([
                        AssetField.listPrice,
                        AssetField.listPriceDate,
                        AssetField.listPriceDiscount,
                        AssetField.listPriceSalesSupport,
                    ]),
                },
                {
                    title: t('asset.salesPrice'),
                    items: getFields([
                        AssetField.recommendedSalesPrice,
                        AssetField.recommendedSalesPriceAdjusted,
                    ]),
                },
                {
                    items: getFields([
                        AssetField.initialCondition,
                        AssetField.assetOrigin,
                    ]),
                },
                {
                    title: t('asset.productGroupNumber'),
                    items: getFields([
                        AssetField.productGroup,
                        AssetField.assetCategory,
                        AssetField.assetType,
                    ]),
                },
            ],
            editLink: getEditLink?.(AssetStep.finance),
            onEditClick: onEditClick ? () => onEditClick(AssetStep.finance) : undefined,
        }
    ]


    return (
        <Summary data={summaryData} />
    )
}

export default AssetDataFinance
